import { Card, CardBody } from "./../../../components/card/card.jsx";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dashboardTrainingInstructorHour } from "../../../config/apiSPA.js";
import SpinnerSectionContent from "../../../components/spinner/spinnerSectionContent.jsx";
function TeachingHours() {
  const [teachHours, setTeachHours] = useState([]);
  const [loadingPage, setLoadingPage] = useState(true);

  const loadData = async () => {
    setLoadingPage(true);
    try {
      const res = await dashboardTrainingInstructorHour();
      setTeachHours(res.data);
      setLoadingPage(false);
    } catch (error) {
    } finally {
      setLoadingPage(false);
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <Card>
        <CardBody>
          <h5>Instructor Teaching Days</h5>

          {console.log(teachHours)}
          {loadingPage ? (
            <SpinnerSectionContent />
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered text-center table-hover text-nowrap">
                <thead className="align-middle">
                  <tr>
                    <th rowSpan="2">Name</th>
                    <th colSpan="2">Teaching Days</th>
                    <th colSpan="2">longest Teaching Days</th>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <th>Current Year</th>
                    <th>Title</th>
                    <th>Teaching Days</th>
                  </tr>
                </thead>
                <tbody className="align-middle">
                  {teachHours.map((val, index) => (
                    <tr key={index}>
                      <td>{val.namaInstructor}</td>
                      <td className="text-theme">{val.totalTeachingDay}</td>
                      <td>{val.currentYearTeachingDay}</td>

                      <td>{val.longestTeachingDay ? val.longestTeachingKodeTrId : "-"}</td>
                      <td>{val.longestTeachingDay ? val.longestTeachingDay : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
}

export default TeachingHours;
